import { queryParams, type RouteQueryOptions, type RouteDefinition, applyUrlDefaults } from './../../../../../wayfinder'
/**
* @see \App\Http\Controllers\ActivityLog\UpdateCustomActivityLogController::__invoke
* @see app/Http/Controllers/ActivityLog/UpdateCustomActivityLogController.php
* @route '/api/activity/{activity}'
*/
const UpdateCustomActivityLogController = (args: { activity: string | { id: string } } | [activity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateCustomActivityLogController.url(args, options),
    method: 'put',
})

UpdateCustomActivityLogController.definition = {
    methods: ["put"],
    url: '/api/activity/{activity}',
} satisfies RouteDefinition<["put"]>

/**
* @see \App\Http\Controllers\ActivityLog\UpdateCustomActivityLogController::__invoke
* @see app/Http/Controllers/ActivityLog/UpdateCustomActivityLogController.php
* @route '/api/activity/{activity}'
*/
UpdateCustomActivityLogController.url = (args: { activity: string | { id: string } } | [activity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions) => {
    if (typeof args === 'string' || typeof args === 'number') {
        args = { activity: args }
    }

    if (typeof args === 'object' && !Array.isArray(args) && 'id' in args) {
        args = { activity: args.id }
    }

    if (Array.isArray(args)) {
        args = {
            activity: args[0],
        }
    }

    args = applyUrlDefaults(args)

    const parsedArgs = {
        activity: typeof args.activity === 'object'
        ? args.activity.id
        : args.activity,
    }

    return UpdateCustomActivityLogController.definition.url
            .replace('{activity}', parsedArgs.activity.toString())
            .replace(/\/+$/, '') + queryParams(options)
}

/**
* @see \App\Http\Controllers\ActivityLog\UpdateCustomActivityLogController::__invoke
* @see app/Http/Controllers/ActivityLog/UpdateCustomActivityLogController.php
* @route '/api/activity/{activity}'
*/
UpdateCustomActivityLogController.put = (args: { activity: string | { id: string } } | [activity: string | { id: string } ] | string | { id: string }, options?: RouteQueryOptions): RouteDefinition<'put'> => ({
    url: UpdateCustomActivityLogController.url(args, options),
    method: 'put',
})

export default UpdateCustomActivityLogController